import { LoadingOverlay } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { SmallModal } from '../../../components/SmallModal';
import { useModal } from '../../../hooks/useModal';
import { mutate } from '../../../util/api/mutate';
import type { RearDisplayDto } from '../types/RearDisplayDto';

interface ModerateModalProps {
	close: () => void;
	isOpened: boolean;
	displayDescription: string;
	advertId: string;
	triggerUpdateInList: (r: RearDisplayDto) => void;
}

export function ModerateModal({
	close,
	isOpened,
	displayDescription,
	advertId,
	triggerUpdateInList,
}: ModerateModalProps) {
	const { organisation } = useParams();

	const completeModal = useModal();

	const moderateMutation = mutate<RearDisplayDto>(
		`${organisation}/rear-display/moderate/${advertId}`,
	);

	return (
		<>
			<LoadingOverlay
				bg={'#000'}
				opacity={0.85}
				visible={moderateMutation.isLoading}
			/>
			<SmallModal
				isOpen={isOpened}
				close={close}
				title={'Moderate Rear Display'}
				body={
					<>
						Are you sure you want to moderate <i>{displayDescription}</i>? Click
						OK to confirm...
					</>
				}
				onComplete={async () => {
					close();

					await moderateMutation
						.mutateAsync()
						.then((data) => triggerUpdateInList(data.value))
						.then(() => completeModal.open());
				}}
			/>
			<SmallModal
				isOpen={completeModal.isOpen}
				close={completeModal.close}
				title={'Moderation Complete'}
				body={
					<>
						Moderation of <i>{displayDescription}</i> has successfully
						completed. Click OK to continue...
					</>
				}
			/>
		</>
	);
}
